import type { ReactNode } from "react";
import { Modal, ProductImage } from "../../components/index.js";
import type { PrepDetailsItem } from "../../types.js";

/**
 * Modal "Consulte o modelo de embalagem" (Design.md §6.1): imagem + dados do SKU,
 * modelo, categoria de preparação, quem etiqueta, e o aviso normativo literal
 * sobre o fim dos serviços de preparação da Amazon.
 */
export interface PackingModeloModalProps {
  msku: string | null;
  asin: string | null;
  prep: PrepDetailsItem | null;
  /** Imagem do produto (join com inventário) — exibida no topo. */
  imageUrl?: string;
  productName?: string;
  onClose: () => void;
}

export function PackingModeloModal({
  msku,
  asin,
  prep,
  imageUrl,
  productName,
  onClose
}: PackingModeloModalProps): ReactNode {
  return (
    <Modal
      open={msku !== null}
      onClose={onClose}
      title="Consulte o modelo de embalagem"
      width={520}
    >
      {msku !== null ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "0.2rem" }}>
            <ProductImage src={imageUrl ?? ""} label={productName || msku} size={56} />
            {productName !== undefined && productName.length > 0 ? (
              <span style={{ fontWeight: 600, fontSize: 13.5 }}>{productName}</span>
            ) : null}
          </div>
          <Row label="SKU" value={<span className="mono">{msku}</span>} />
          <Row label="ASIN" value={<span className="mono">{prep?.asin ?? asin ?? "—"}</span>} />
          <Row label="Modelo de embalagem" value="Unidades individuais" />
          <Row label="Categoria de preparação" value={prep?.prepCategory ?? "—"} />
          <Row
            label="Quem etiqueta as unidades?"
            value={labelOwnerLabel(prep?.labelOwner ?? null)}
          />
          <p
            style={{
              marginTop: "0.5rem",
              fontSize: 12,
              color: "var(--amber)",
              fontWeight: 600
            }}
          >
            A partir de 1 de julho de 2026, a Amazon não oferecerá mais os serviços
            de preparação e etiquetagem.
          </p>
        </div>
      ) : null}
    </Modal>
  );
}

function Row({ label, value }: { label: string; value: ReactNode }): ReactNode {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem" }}>
      <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{label}</span>
      <span style={{ fontSize: 12.5, fontWeight: 600 }}>{value}</span>
    </div>
  );
}

export function labelOwnerLabel(owner: string | null): string {
  if (owner === null) {
    return "—";
  }
  const upper = owner.toUpperCase();
  if (upper === "SELLER") {
    return "Pelo vendedor";
  }
  if (upper === "AMAZON") {
    return "Pela Amazon";
  }
  return owner;
}
